var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_583_12722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.150391,
    y: 0.40332,
    width: 24.2017,
    height: 24.2017,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_583_12722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18418 18.554C3.89847 18.554 3.65914 18.4572 3.4662 18.2635C3.27259 18.0706 3.17578 17.8313 3.17578 17.5456C3.17578 17.2598 3.27259 17.0205 3.4662 16.8276C3.65914 16.634 3.89847 16.5372 4.18418 16.5372H20.3186C20.6044 16.5372 20.8437 16.634 21.0366 16.8276C21.2302 17.0205 21.327 17.2598 21.327 17.5456C21.327 17.8313 21.2302 18.0706 21.0366 18.2635C20.8437 18.4572 20.6044 18.554 20.3186 18.554H4.18418ZM4.18418 13.5119C3.89847 13.5119 3.65914 13.4151 3.4662 13.2215C3.27259 13.0286 3.17578 12.7893 3.17578 12.5035C3.17578 12.2178 3.27259 11.9782 3.4662 11.7846C3.65914 11.5916 3.89847 11.4951 4.18418 11.4951H20.3186C20.6044 11.4951 20.8437 11.5916 21.0366 11.7846C21.2302 11.9782 21.327 12.2178 21.327 12.5035C21.327 12.7893 21.2302 13.0286 21.0366 13.2215C20.8437 13.4151 20.6044 13.5119 20.3186 13.5119H4.18418ZM4.18418 8.46993C3.89847 8.46993 3.65914 8.37346 3.4662 8.18052C3.27259 7.98691 3.17578 7.74724 3.17578 7.46153C3.17578 7.17581 3.27259 6.93615 3.4662 6.74254C3.65914 6.5496 3.89847 6.45312 4.18418 6.45312H20.3186C20.6044 6.45312 20.8437 6.5496 21.0366 6.74254C21.2302 6.93615 21.327 7.17581 21.327 7.46153C21.327 7.74724 21.2302 7.98691 21.0366 8.18052C20.8437 8.37346 20.6044 8.46993 20.3186 8.46993H4.18418Z",
    fill: "#586A84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.69fbc51e5159526a31582020a14accbc.svg";
export { ForwardRef as ReactComponent };